import React, { useCallback, useMemo } from "react";
import { useStyles } from "./style";
import { Select, MenuItem, FormControl, InputLabel, FormHelperText, Chip, Input, Checkbox } from "@material-ui/core";

function SelectComponent(props) {
  const classes = useStyles();
  const { onChange, value, disabled = false, multiple = false, options = [], label, mb, error, helperText, autoWidth = false } = props;
  const optionNames = useMemo(() => {
    let keys = {};
    if (Array.isArray(options)) {
      options.forEach((element) => {
        keys[element?.id] = element?.name;
      });
    }
    return keys;
  }, [options]);

  const handleChipDelete = (chipValue, event) => {
    event.stopPropagation();
    const newValue = value.filter((v) => v !== chipValue);
    // Create a synthetic event to maintain consistency with the onChange handler
    const syntheticEvent = {
      target: {
        value: newValue,
      },
    };
    onChange(syntheticEvent);
  };

  return (
    <FormControl variant="outlined" size="small" fullWidth mb={mb} error={error}>
      <InputLabel htmlFor="outlined-age-native-simple">{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        multiple={multiple}
        inputProps={{
          name: label,
          id: "outlined-age-native-simple",
        }}
        input={multiple ? <Input id="select-multiple-chip" /> : undefined}
        renderValue={
          multiple
            ? (selected) => (
                <>
                  {selected.map((value) => (
                    <Chip
                      key={value}
                      label={optionNames[value]}
                      className={classes.chip}
                      onMouseDown={(event) => event.stopPropagation()}
                      onDelete={(event) => handleChipDelete(value, event)}
                    />
                  ))}
                </>
              )
            : undefined
        }
        disabled={disabled}
        autoWidth
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.id.toString()} disabled={option.id.toString() === value}>
            {multiple ? <Checkbox checked={value?.indexOf(option.id.toString()) > -1} /> : null}
            {option.name}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}

export default SelectComponent;
